module.exports = __webpack_public_path__ + "img/downIcon.23a5e8ae.svg";